import { apiFetch } from "./client";

export interface Issue {
  id: string;
  companyId: string;
  projectId: string | null;
  goalId: string | null;
  parentId: string | null;
  title: string;
  description: string | null;
  status: string;
  priority: string;
  assigneeAgentId: string | null;
  assigneeUserId: string | null;
  issueNumber: number | null;
  identifier: string | null;
  startedAt: string | null;
  completedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export const issuesApi = {
  list: (companyId: string) => apiFetch<Issue[]>(`/issues?companyId=${companyId}`),
  get: (id: string) => apiFetch<Issue>(`/issues/${id}`),
  create: (data: Record<string, unknown>) =>
    apiFetch<Issue>("/issues", { method: "POST", body: JSON.stringify(data) }),
  update: (id: string, data: Record<string, unknown>) =>
    apiFetch<Issue>(`/issues/${id}`, { method: "PATCH", body: JSON.stringify(data) }),
  delete: (id: string) => apiFetch<void>(`/issues/${id}`, { method: "DELETE" }),
};
